import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, mergeProps as _mergeProps, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-bs-toggle", "href", "aria-controls", "aria-expanded"];
const _hoisted_2 = {
  class: "icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
};
import { ref, toRefs, watch } from 'vue';
import { useLayoutStore } from '@/store/modules/layout';
export default {
  __name: 'SidenavCollapse',
  props: {
    collapseRef: {
      type: String,
      required: true
    },
    navText: {
      type: String,
      required: true
    },
    collapse: {
      type: Boolean,
      default: true
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;

    // props 정의
    const props = __props;
    const {
      collapseRef,
      navText,
      collapse,
      isActive
    } = toRefs(props);

    // store에서 layout 정보 가져오기
    const layoutStore = useLayoutStore();

    // data()에서 사용했던 상태들을 ref로 정의
    const isExpanded = ref(isActive.value);
    const isRTL = ref(layoutStore.isRTL);
    const click = () => {
      isExpanded.value = !isExpanded.value;
      emits('click');
    };
    watch(() => isActive.value, value => {
      isExpanded.value = value;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("a", _mergeProps({
        "data-bs-toggle": _unref(collapse) ? 'collapse' : '',
        href: _unref(collapse) ? `#${_unref(collapseRef)}` : _unref(collapseRef),
        "aria-controls": _unref(collapseRef),
        "aria-expanded": isExpanded.value,
        class: "nav-link"
      }, _ctx.$attrs, {
        onClick: _cache[0] || (_cache[0] = $event => click())
      }), [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "icon")]), _createElementVNode("span", {
        class: _normalizeClass(["nav-link-text", isRTL.value ? ' me-1' : 'ms-1'])
      }, _toDisplayString(_unref(navText)), 3)], 16, _hoisted_1), _createElementVNode("div", {
        class: _normalizeClass(isExpanded.value || _unref(isActive) ? 'collapse show' : 'collapse')
      }, [_renderSlot(_ctx.$slots, "list")], 2)], 64);
    };
  }
};